export var OvpJourneyContext;
(function (OvpJourneyContext) {
    OvpJourneyContext["Binge"] = "BINGE";
    OvpJourneyContext["Standard"] = "STANDARD";
    OvpJourneyContext["AssetRetry"] = "ASSET_RETRY";
    OvpJourneyContext["VpfRetry"] = "VPF_RETRY";
    OvpJourneyContext["ErrorRetry"] = "ERROR_RETRY";
    OvpJourneyContext["Autoplay"] = "AUTOPLAY";
    OvpJourneyContext["PreFetch"] = "PRE_FETCH";
    OvpJourneyContext["LivePreview"] = "LIVE_PREVIEW";
    OvpJourneyContext["ImmersiveHighlights"] = "IMMERSIVE_HIGHLIGHTS";
    OvpJourneyContext["MiniPlayer"] = "MINI_PLAYER";
    OvpJourneyContext["UmvRefresh"] = "UMV_REFRESH";
    OvpJourneyContext["SleAutoplay"] = "AUTOPLAY_SLE";
})(OvpJourneyContext || (OvpJourneyContext = {}));
export var OvpErrorSource;
(function (OvpErrorSource) {
    OvpErrorSource[OvpErrorSource["PLAYOUT"] = 0] = "PLAYOUT";
    OvpErrorSource[OvpErrorSource["PLAYER"] = 1] = "PLAYER";
    OvpErrorSource[OvpErrorSource["TOKEN_EXCHANGE"] = 2] = "TOKEN_EXCHANGE";
})(OvpErrorSource || (OvpErrorSource = {}));
/**
 * @public
 */
export var OvpVideoFormat;
(function (OvpVideoFormat) {
    OvpVideoFormat["HD"] = "HD";
    OvpVideoFormat["SD"] = "SD";
    OvpVideoFormat["UHD"] = "UHD";
    OvpVideoFormat["UNKNOWN"] = "UNKNOWN";
})(OvpVideoFormat || (OvpVideoFormat = {}));
/**
 * @public
 */
export var OvpColourSpace;
(function (OvpColourSpace) {
    OvpColourSpace["DolbyVision"] = "DolbyVision";
    OvpColourSpace["HDR10"] = "HDR10";
    OvpColourSpace["HLG"] = "HLG";
    OvpColourSpace["SDR"] = "SDR";
})(OvpColourSpace || (OvpColourSpace = {}));
/**
 * @public
 */
export var OvpVideoCodec;
(function (OvpVideoCodec) {
    OvpVideoCodec["H264"] = "H264";
    OvpVideoCodec["H265"] = "H265";
})(OvpVideoCodec || (OvpVideoCodec = {}));
export var StreamTransport;
(function (StreamTransport) {
    StreamTransport["HLS"] = "HLS";
    StreamTransport["HSS"] = "HSS";
    StreamTransport["PDL"] = "PDL";
    StreamTransport["DASH"] = "DASH";
    StreamTransport["PSF"] = "PSF";
})(StreamTransport || (StreamTransport = {}));
export var OvpNielsenTrackingType;
(function (OvpNielsenTrackingType) {
    OvpNielsenTrackingType["DTVR"] = "DTVR";
    OvpNielsenTrackingType["DCR"] = "DCR";
    // eslint-disable-next-line camelcase
    OvpNielsenTrackingType["not_required"] = "not_required";
})(OvpNielsenTrackingType || (OvpNielsenTrackingType = {}));
export var ProgramRestrictions;
(function (ProgramRestrictions) {
    ProgramRestrictions["EMBARGO"] = "embargo";
    ProgramRestrictions["NONE"] = "none";
})(ProgramRestrictions || (ProgramRestrictions = {}));
export var DvrWindowDurationValues;
(function (DvrWindowDurationValues) {
    DvrWindowDurationValues["TWO_MIN"] = "2min";
    DvrWindowDurationValues["TWO_HOUR"] = "2hr";
    DvrWindowDurationValues["FOUR_HOUR"] = "4hr";
})(DvrWindowDurationValues || (DvrWindowDurationValues = {}));
//# sourceMappingURL=playout.js.map